import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { AnimatedLogo } from "../components/site/AnimatedLogo";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="glow-bg flex min-h-screen items-center justify-center px-6">
      <form onSubmit={submit} className="panel w-full max-w-sm space-y-4 p-8" data-testid="admin-login-form">
        <AnimatedLogo className="mx-auto w-24" testId="admin-login-logo" />
        <h1 className="text-center font-display text-3xl font-black uppercase">Admin Login</h1>
        <div><label className="label">Email</label><input className="field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" /></div>
        <div><label className="label">Password</label><input className="field" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" /></div>
        {error && <p className="rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button className="btn-red w-full" disabled={busy} data-testid="admin-login-submit-button">{busy ? "Signing in..." : "Sign In"}</button>
      </form>
    </div>
  );
}
